/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { get as getUser } from 'js/lib/user';

import { Typography2 } from '@coursera/cds-core';

import CoachIcon from 'bundles/ai-coach-platform/components/branding/CoachIcon';
import { firstNameFromFullName } from 'bundles/ai-course-coach/utils/nameParser';

import _t from 'i18n!nls/learning-assistant-chat-ai';

const styles = {
  personalizedWelcome: (direction: 'top' | 'right') => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--cds-spacing-200);
    padding: var(--cds-spacing-200);
    animation: ${direction === 'top' ? 'animateTop' : 'animateRight'} 0.4s ease-in-out;

    @keyframes animateTop {
      from {
        opacity: 0;
        transform: translateY(-25%);
      }

      to {
        opacity: 1;
        transform: translateY(0%);
      }
    }

    @keyframes animateRight {
      from {
        opacity: 0;
        transform: translateX(25%);
      }

      to {
        opacity: 1;
        transform: translateX(0%);
      }
    }

    .title {
      color: var(--cds-color-emphasis-primary-background-default);
    }

    .subtitle {
      margin: 0;
    }
  `,
};

const WelcomeBanner = ({ direction = 'top' }: { direction?: 'top' | 'right' }) => {
  const { fullName: userName } = getUser();
  const userFirstName = userName ? firstNameFromFullName(userName) : null;
  const displayTitle = _t('Hello and welcome, #{userName}!', { userName: userFirstName ?? _t('learner') });
  return (
    <div css={styles.personalizedWelcome(direction)}>
      <CoachIcon size="large" />
      <Typography2 component="h3" variant="titleSmall" className="title">
        {displayTitle}
      </Typography2>
    </div>
  );
};

export default WelcomeBanner;
